import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Zoom as ZoomButton } from '@tmapy/style-guide';
import { useMessage } from '@tmapy/intl';
import { actionAddZoom, actionSetZoom } from '../../actions';
export const Zoom = ({ inTooltip, outTooltip, dispatch, view, zoomLevelShortcuts, }) => {
    const formatMessage = useMessage();
    const zoomIn = useCallback(() => {
        dispatch(actionAddZoom(+1));
    }, [dispatch]);
    const zoomOut = useCallback(() => {
        dispatch(actionAddZoom(-1));
    }, [dispatch]);
    const zoom = view.zoom;
    const levels = useMemo(() => {
        if (!zoomLevelShortcuts)
            return;
        return zoomLevelShortcuts.map((level) => {
            const minZoom = level.zoom - level.delta;
            const maxZoom = level.zoom + level.delta;
            return {
                id: level.id,
                label: formatMessage.fallback([`zoom.${level.id}.label`]) ?? level.id,
                tooltip: formatMessage.fallback([`zoom.${level.id}.tooltip`]) ?? level.id,
                isActive: minZoom <= zoom && zoom < maxZoom,
                onClick: () => {
                    dispatch(actionSetZoom(level.zoom));
                },
            };
        });
    }, [zoom, zoomLevelShortcuts, formatMessage, dispatch]);
    return (_jsx(ZoomButton, { inTooltip: inTooltip, outTooltip: outTooltip, isInDisabled: view.maxZoom === view.zoom, isOutDisabled: view.minZoom === view.zoom, levels: levels, onInClick: zoomIn, onOutClick: zoomOut }));
};
//# sourceMappingURL=Zoom.js.map